import styled from "styled-components"
import {Col} from "react-bootstrap"
import Flex from "@irati/ui/src/Flex"

export const FlexRow = styled(Flex)`
  border-top: 1px solid ${({theme}) => theme.colors.greys.light};
`

export const FirstCol = styled(Col)`
  padding-left: 0;
`
export const EndCol = styled(Col)`
  padding-right: 0;
`

export const BrandLogo = styled.img`
  width: 100%;
`
